import StockManager from './StockManager'
export default StockManager